<template>
  <BasePage title="Tags">
    <div class="columns">
      <div class="column is-half-desktop is-offset-one-quarter-desktop">

        <TagManager />

      </div>
    </div>
  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'
import TagManager from './TagManager.vue'

export default {
  name: 'manage',
  components: {
    BasePage,
    TagManager
  },
}

</script>



// WEBPACK FOOTER //
// Tags.vue?4407f4ca